import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './ClientDetailsComponent.metadata.json5';
import styles from '../MedicalPractitioners.module.scss';

function ClientDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ClientDetailsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        pleAdvWhaAgeAndUndWha5: {
            visible: !_.isUndefined(modelVM.indUndAgeOf164.value) && modelVM.indUndAgeOf164.value
        },
        doYouObtWriParAgr6: {
            visible: !_.isUndefined(modelVM.indUndAgeOf164.value) && modelVM.indUndAgeOf164.value
        },
        ifOthPleSpe9: {
            visible: !_.isUndefined(modelVM.oth8.value) && modelVM.oth8.value
        },
        ifYesPleLisAllLeaAgr11: {
            visible: !_.isUndefined(modelVM.areTheAnyKnoConOblWhe10.value) && modelVM.areTheAnyKnoConOblWhe10.value
        },
        wasTheCasSet21: {
            visible: !_.isUndefined(modelVM.havAnyIncResInAnAll20.value) && modelVM.havAnyIncResInAnAll20.value
        },
        wasTheCasTakToTri22: {
            visible: !_.isUndefined(modelVM.havAnyIncResInAnAll20.value) && modelVM.havAnyIncResInAnAll20.value
        },
        amoPaiForDamToTheVic23: {
            visible: !_.isUndefined(modelVM.havAnyIncResInAnAll20.value) && modelVM.havAnyIncResInAnAll20.value,
            defaultValue: { amount: 0, currency: 'cad' }
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ClientDetailsComponent.propTypes = wizardProps;
export default withRouter(ClientDetailsComponent);
